// @flow
import React from "react";
import {DownloadAppImg} from "./DownloadAppStyle";
import { images } from '../../config';

type OwnProps = {|
    onDownloadClick: () => void
|}

const DownloadApp = (props: OwnProps) => {
    return (
        <div>
            <DownloadAppImg src={images.download_app_icon} alt={`download app icon`} onClick={props.onDownloadClick}/>
        </div>
    );

};

export default DownloadApp;



// WEBPACK FOOTER //
// ./src/Components/DownloadApp/DownloadApp.js